import { render, staticRenderFns } from "./sectionCategories.vue?vue&type=template&id=33a23952&"
import script from "./sectionCategories.vue?vue&type=script&lang=js&"
export * from "./sectionCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports